import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

const SECTIONS = [
  {
    h: "1. Acceptance of terms · 条款接受",
    p: [
      "By applying for membership, signing in, or using Lumière Club in any way, you agree to be bound by these Terms of Service and the Privacy Policy. If you do not agree, do not use the platform.",
      "申请会员、登入、或以任何方式使用 Lumière Club，即视为您同意受本《服务条款》及《隐私政策》约束。若您不同意，请勿使用本平台。",
    ],
  },
  {
    h: "2. Membership · 会员资格",
    p: [
      "Lumière Club is an invitation-only community for adults aged 21 and above residing in Malaysia (or with strong Malaysian ties). Membership is granted at the sole discretion of the Concierge (administrator) after review of your application, referral code, and profile information.",
      "You must provide accurate and truthful information. Impersonation, false referral codes, or misrepresentation will result in immediate rejection or removal.",
      "Lumière Club 是仅供 21 岁以上、居住于马来西亚（或与马来西亚有紧密联系）之成年人参与的邀请制社群。会员资格由 Concierge（管理员）审阅您的申请、推荐码和资料后自行决定授予。",
      "您必须提供真实准确之资料。冒充他人、伪造推荐码或虚假陈述将导致立即拒绝或除名。",
    ],
  },
  {
    h: "3. Community standards · 社群规范",
    p: [
      "You agree NOT to:",
      "• Share contact information (phone, WeChat, WhatsApp, Facebook, Instagram, Xiaohongshu, etc.) in Stories, group chat, or DMs — only the Concierge may do so.",
      "• Post sexual, obscene, hateful, harassing, or illegal content.",
      "• Solicit, advertise, or engage in commercial promotion without prior written approval from the Concierge.",
      "• Circumvent our moderation systems, create multiple accounts, or reverse-engineer the platform.",
      "Violation of community standards will result in an automatic 7-day mute for the first offence. Repeat or severe violations will result in permanent account termination.",
      "您同意 不 从事以下行为：",
      "• 在动态、群组聊天或私信中分享联系方式（电话、微信、WhatsApp、脸书、IG、小红书等） — 仅 Concierge 可分享。",
      "• 发布性、猥亵、仇恨、骚扰或非法内容。",
      "• 未经 Concierge 书面同意进行招揽、广告或商业推广。",
      "• 规避审核机制、注册多个账户或对平台进行逆向工程。",
      "违反社群规范者首次违规将被自动禁言 7 天。重复或严重违规者将被永久终止账户。",
    ],
  },
  {
    h: "4. Content ownership & licence · 内容归属与授权",
    p: [
      "You retain ownership of all content you post to Lumière Club (Stories, group posts, comments, DMs, event content, profile information). By posting, you grant Lumière Club a non-exclusive, worldwide, royalty-free licence to store, display, and moderate that content solely for the purpose of operating the platform.",
      "Stories automatically expire and are deleted 24 hours after posting. Other content (group posts, event photos, profile) is retained until you delete it or terminate your account.",
      "您对发布至 Lumière Club 的所有内容（动态、群组帖子、评论、私信、活动内容、个人资料）保有所有权。发布即代表您授予 Lumière Club 一项非独占、全球性、免版税之许可，仅用于为运营平台之目的储存、展示与审核您的内容。",
      "动态发布 24 小时后自动过期并删除。其他内容（群组帖子、活动照片、个人资料）在您删除或终止账户前一直保留。",
    ],
  },
  {
    h: "5. Moderation & administration · 审核与管理",
    p: [
      "The Concierge (administrator) may, at any time and without prior notice: review any content or conversation (including DMs) for the purpose of enforcing these Terms; remove content that violates community standards; mute, suspend, or terminate any account.",
      "We aim to apply these powers fairly and in the interest of the community. If you believe an action taken against your account is in error, you may appeal by emailing the Concierge.",
      "Concierge（管理员）可在任何时间、无须事先通知：为执行本条款而审查任何内容或对话（包括私信）、移除违反社群规范之内容、禁言、暂停或终止任何账户。",
      "我们致力于公平并以社群利益为准执行上述权力。若您认为对您账户之处置有误，可来信 Concierge 提出申诉。",
    ],
  },
  {
    h: "6. Termination · 终止",
    p: [
      "You may terminate your account at any time by contacting the Concierge. Upon termination, we will delete your profile and content from our systems (subject to a short technical retention window for backups).",
      "We may terminate your account for material breach of these Terms, extended inactivity, or if we cease operating the platform.",
      "您可随时联系 Concierge 终止您的账户。终止后我们会将您的资料与内容从系统中删除（备份存有短暂的技术留存期）。",
      "若您严重违反本条款、长时间不活跃，或本平台停止运营，我们亦可终止您的账户。",
    ],
  },
  {
    h: "7. Disclaimer of warranties · 免责声明",
    p: [
      "Lumière Club is provided \"as is\" and \"as available\", without warranties of any kind, express or implied. We do not guarantee that the platform will be uninterrupted, error-free, or fully secure. Member profiles and content are contributed by members themselves; we do not verify credentials, income claims, or occupation independently.",
      "You are solely responsible for your interactions with other members. Meet at your own discretion and in safe, public settings.",
      "Lumière Club 系「按现状」及「视可用性」提供，不作任何明示或默示保证。我们不保证平台永不中断、无错误或完全安全。会员资料及内容由会员自行提供，我们不独立核实其证件、收入声明或职业。",
      "您对与其他会员之互动负全部责任。见面请自行斟酌，选择安全的公共场所。",
    ],
  },
  {
    h: "8. Limitation of liability · 责任限制",
    p: [
      "To the maximum extent permitted by law, Lumière Club and its Concierge shall not be liable for any indirect, incidental, consequential, or punitive damages arising from your use of the platform. Our total liability, if any, shall not exceed the amount you have paid (if any) to Lumière Club in the preceding twelve months.",
      "在法律允许之最大范围内，Lumière Club 及其 Concierge 概不就您使用本平台产生之任何间接、附带、后果性或惩罚性损害负责。我们之总责任（如有）不超过您于前十二个月内已支付予 Lumière Club 之款项（若有）。",
    ],
  },
  {
    h: "9. Governing law · 适用法律",
    p: [
      "These Terms are governed by the laws of Malaysia. Any dispute arising from these Terms or your use of the platform shall be submitted to the exclusive jurisdiction of the courts of Kuala Lumpur, Malaysia.",
      "本条款受马来西亚法律管辖。因本条款或您使用本平台产生之任何争议，将提交予马来西亚吉隆坡法院之专属管辖。",
    ],
  },
  {
    h: "10. Changes to these terms · 条款更新",
    p: [
      "We may update these Terms from time to time. Material changes will be announced via in-app broadcast and push notification. Continued use of Lumière Club after such changes constitutes your acceptance of the updated Terms.",
      "我们可能不时更新本条款。重大更动将通过站内广播及推送通知发出。您在条款更动后继续使用 Lumière Club，即视为接受更新后之条款。",
    ],
  },
  {
    h: "11. Contact · 联系我们",
    p: [
      "For any questions, appeals, or requests related to these Terms, please email concierge@lumiere.club or message the Concierge directly inside the app.",
      "如对本条款有任何疑问、申诉或要求，请来信 concierge@lumiere.club，或在 App 内直接私信 Concierge。",
    ],
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen grain bg-[#0a0a0a] text-white/85" data-testid="terms-page">
      <header className="border-b border-white/10 bg-[#0a0a0a]/80 backdrop-blur sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="terms-home-link">
            <span className="w-8 h-8 rounded-full border border-[#d4af37]/60 flex items-center justify-center">
              <span className="text-[#d4af37] font-serif">L</span>
            </span>
            <span className="font-serif text-xl tracking-wider">
              Lumière <span className="text-white/40">Club</span>
            </span>
          </Link>
          <Link
            to="/"
            className="text-xs uppercase tracking-[0.2em] text-white/60 hover:text-[#d4af37] flex items-center gap-2"
            data-testid="terms-back"
          >
            <ArrowLeft size={14} strokeWidth={1.5} /> Home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 sm:px-10 py-12 sm:py-16">
        <div className="flex items-center gap-3 text-[#d4af37] text-xs uppercase tracking-[0.3em]">
          <FileText size={14} strokeWidth={1.5} />
          <span>Terms of Service · 服务条款</span>
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl mt-4 leading-tight">
          The house rules of our salon.
        </h1>
        <p className="text-white/50 mt-3 text-sm">
          Last updated · 2026-06-02
        </p>

        <article className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.h} data-testid={`terms-section-${s.h.split(".")[0]}`}>
              <h2 className="font-serif text-2xl text-[#d4af37]/95">{s.h}</h2>
              <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-white/75">
                {s.p.map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>
            </section>
          ))}
        </article>

        <div className="mt-16 border-t border-white/10 pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs uppercase tracking-[0.2em] text-white/40">
          <span>© Lumière Club · Est. 2026</span>
          <div className="flex gap-6">
            <Link to="/" className="hover:text-[#d4af37]" data-testid="terms-footer-home">Home</Link>
            <Link to="/privacy" className="hover:text-[#d4af37]" data-testid="terms-footer-privacy">Privacy</Link>
            <Link to="/apply" className="hover:text-[#d4af37]" data-testid="terms-footer-apply">Apply</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
